import React, { useEffect, useState } from "react";
import "./Order_details.css";
import Order_id_holder from "./order_id_holder/Order_id_holder";
import Order_details_table from "./order_details_table/Order_details_table";
import Order_Status_Stepper from "./order_status_stepper/Order_Status_Stepper";
import Common_Back_Header from "../../../../common/common_components/common_back_header/Common_Back_Header";
import Receiver_info_holder from "./receiver_info_holder/Receiver_info_holder";
import Payment_Summary from "./payment_summary/Payment_Summary";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../../../../features/order/orderSlice";
import { IDS } from "../../../../../utils/IDS";
import { decodeId, encodeId } from "../../../../../utils/common";


function Order_details() {
  // const data = [
  //   {
  //     date: "Today",
  //     time: "9:10 am",
  //     title: "Parcel Received from shop",
  //     address: "Datta Mandir Chowk, Pune, Maharashtra 411014, India",
  //     status: "done",
  //   },
  //   {
  //     date: "21.JUN.2025",
  //     time: "1:30 pm",
  //     title: "Parcel In Processing",
  //     address: "Datta Mandir Chowk, Pune, Maharashtra 411014, India",
  //     status: "done",
  //   },
  //   {
  //     date: "22.JUN.2025",
  //     time: "2:14 pm",
  //     title: "Parcel arrived in transit site",
  //     address: "Datta Mandir Chowk, Pune, Maharashtra 411014, India",
  //     status: "done",
  //   },
  //   {
  //     date: "23.JUN.2025",
  //     time: "8:17 am",
  //     title: "Parcel on the way",
  //     address: "Datta Mandir Chowk, Pune, Maharashtra 411014, India",
  //     status: "pending",
  //   },
  //   {
  //     date: "25.JUN.2025",
  //     time: "9:00 am",
  //     title: "Estimated Date of delivery",
  //     address: "Datta Mandir Chowk, Pune, Maharashtra 411014, India",
  //     status: "pending",
  //   },
  // ];

  const [showStepper, setShowStepper] = useState(false);
  // const [showCancelBtn, setShowCancelBtn] = useState(false);

  const orderStatusClickFunc = () => {
    setShowStepper(true);
  };


  const { id } = useParams();

  const dispatch = useDispatch();
  const order = useSelector((state) => state.order.order);
  useEffect(() => {
    dispatch(getOrder(decodeId(id)));

  }, [id, dispatch]);


  const data = {
    total_mrp: order?.total_mrp,
    total_tax: order?.total_tax,
    total_cess: order?.cess_tax,
    no_of_item: order?.no_of_item,
    total_selling_price: order?.total_selling_price,
    total_selling_price_gst: order?.total_selling_price_gst,
    total_mrp_gst: order?.total_mrp_gst,
    total_coupon_discount: order?.total_coupon_discount,
    total_offer_discount: order?.total_offer_discount,
    grand_total: order?.total_amount,
    total_delivery_charges: order?.delivery_charges,
    platform_fee: order?.platform_fee,
    payment_method: order?.Payment_Method?.name,
    total_savings: order?.total_mrp - order?.total_selling_price
  };



  return (
    <>
      <section className="Order_details">
        <div className="container">
          <Common_Back_Header
            backNavigation="/profile"
            showOrderStatus
            orderStatusClick={orderStatusClickFunc}
          />

          <div className="row">
            <div className=" col-lg-8 col-md-7">
              <Order_id_holder headingText={`Order ID #${order?.invoice_no}`} date={order?.createdAt} subText={order?.Order_status?.name}
              />
              <Order_details_table products={order?.Product_Order_Details || []} />

              {showStepper && <Order_Status_Stepper OrderStatus={order || []} setShowStepper={setShowStepper} />}
            </div>
            <div className="col-lg-4 col-md-5">
              <Receiver_info_holder showCancelBtn User={order?.User} Address={order?.User_Address} id={decodeId(id)} deliveryStatus={order?.order_status_id < 2} TrakingID={order?.tracking_id || null} />

              <Payment_Summary isCheckoutPage data={data} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Order_details;
